"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign_in_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const local_storage_names_1 = require("../../../../constants/local_storage_names");
const main_1 = require("../../main");
const user_1 = require("../user");
const sign_in_1 = require("../../../../api/calls/user/sign_in");
const authHelpers_1 = require("../../../../firebase/authHelpers");
const access_auth_thunk_1 = require("./access_auth_thunk");
exports.sign_in_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_in_thunk", ({ code }, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const userState = state.userState;
    const { user, isLoading } = userState;
    // Indicate that the API is being called.
    yield dispatch((0, user_1.setIsLoading)(true));
    // Call the API.
    let response = null;
    let payload = {
        email: user.email,
        password: user.password,
    };
    if (code) {
        dispatch((0, user_1.setFaceTecAuthorized)(true));
        payload = { code };
    }
    response = yield (0, sign_in_1.sign_in)(payload);
    // Indicate that the API is done being called.
    yield dispatch((0, user_1.setIsLoading)(false));
    // Handle the response.
    if (response.success) {
        if (code) {
            dispatch((0, access_auth_thunk_1.get_access_details_thunk)({ data: { code }, token: response.content.token }));
        }
        if (user.remember_me) {
            localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(response.content));
        }
        dispatch((0, user_1.setUserToken)(response.content.token));
        dispatch((0, user_1.setUser)(response.content.user));
        // Sign into Firebase for QR auth + Firestore listeners (non-mobile).
        // Use the login credentials provided; if the user object gets cleared, we'd lose the password.
        const emailForFirebase = payload.email;
        const passwordForFirebase = payload.password;
        if (emailForFirebase && passwordForFirebase) {
            (0, authHelpers_1.signInToFirebase)(emailForFirebase, passwordForFirebase, response.content.token).catch((err) => console.error("Firebase sign-in failed:", err));
        }
        return response.content;
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
    return null;
}));
